<!--
  The Changeling mark (public/favicon.svg, drawn in the top bar's colours),
  changing as a changeling does while something loads: its plus becomes a
  minus and back, an added line turning into a removed one. One transform,
  1.4 s a loop. It is still when `still` is set and when the user asked
  for reduced motion, and paused while the tab is hidden.
-->
<script lang="ts">
  interface Props {
    /** Pixels square. */
    size?: number;
    /** Hold the mark still (a load that stopped). */
    still?: boolean;
  }
  let { size = 56, still = false }: Props = $props();

  const reduced = typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
  let hidden = $state(typeof document !== 'undefined' && document.visibilityState === 'hidden');
</script>

<svelte:document onvisibilitychange={() => (hidden = document.visibilityState === 'hidden')} />

<svg
  class="mark"
  viewBox="0 0 32 32"
  width={size}
  height={size}
  aria-hidden="true"
  data-motion={still || reduced ? 'still' : hidden ? 'paused' : 'moving'}
>
  <circle class="disc" cx="16" cy="16" r="16" />
  <path class="bubble" d="M9.5 5h13A4.5 4.5 0 0 1 27 9.5v8.5a4.5 4.5 0 0 1-4.5 4.5H15l-5.5 4.6v-4.7A4.5 4.5 0 0 1 5 18V9.5A4.5 4.5 0 0 1 9.5 5Z" />
  <path class="stroke upright" d="M16 7.6v6.6" />
  <path class="stroke" d="M12.7 10.9h6.6" />
  <path class="stroke smile" d="M12.2 17.3Q16 19.9 19.8 17.3" />
</svg>

<style>
  .mark {
    display: block;
    flex: none;
  }
  .disc {
    fill: var(--nav);
  }
  .bubble {
    fill: var(--navfg);
  }
  .stroke {
    fill: none;
    stroke: var(--nav);
    stroke-width: 3;
    stroke-linecap: round;
  }
  .smile {
    stroke-width: 2.6;
  }
  .upright {
    transform-box: fill-box;
    transform-origin: center;
    animation: shift 1.4s ease-in-out infinite;
  }
  @keyframes shift {
    0%,
    30% {
      transform: scaleY(1);
    }
    46%,
    80% {
      transform: scaleY(0);
    }
    96%,
    100% {
      transform: scaleY(1);
    }
  }
  [data-motion='paused'] .upright {
    animation-play-state: paused;
  }
  [data-motion='still'] .upright {
    animation: none;
  }
  @media (prefers-reduced-motion: reduce) {
    .upright {
      animation: none;
    }
  }
</style>
